<div *ngIf="message" id="alert-box"
     [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }"
    [innerHTML]="message.text"
></div>
